(function () {
  if (window.__AG_LONG_BLOCKS_CLINICAL_STATS_INIT__) {
    return;
  }
  window.__AG_LONG_BLOCKS_CLINICAL_STATS_INIT__ = true;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseStatValue(rawValue) {
    var text = String(rawValue || '').trim();
    var hasPlus = text.indexOf('+') === 0;
    var hasPercent = text.indexOf('%') !== -1;
    var number = parseInt(text.replace(/[^\d]/g, ''), 10);

    if (Number.isNaN(number)) {
      number = 0;
    }

    return {
      number: number,
      hasPlus: hasPlus,
      hasPercent: hasPercent
    };
  }

  function formatStatValue(number, hasPlus, hasPercent) {
    var display = String(Math.round(number));
    if (hasPlus) {
      display = '+' + display;
    }
    if (hasPercent) {
      display = display + '%';
    }
    return display;
  }

  function animateStatValue(element, targetText) {
    var parsed = parseStatValue(targetText);
    var duration = 1400;
    var start = performance.now();

    function frame(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = parsed.number * eased;
      element.textContent = formatStatValue(current, parsed.hasPlus, parsed.hasPercent);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        element.textContent = targetText;
      }
    }

    requestAnimationFrame(frame);
  }

  function initBlock(block) {
    if (block.dataset.clinicalStatsReady === 'true') {
      return;
    }

    var animateEnabled = block.dataset.animate === 'true';
    var items = block.querySelectorAll('.ag-long-blocks__clinical-stats__item');

    if (!animateEnabled || prefersReducedMotion()) {
      block.classList.add('ag-long-blocks__clinical-stats--in-view');
      block.dataset.clinicalStatsReady = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          block.classList.add('ag-long-blocks__clinical-stats--in-view');
          block.dataset.clinicalStatsReady = 'true';
          observer.disconnect();

          items.forEach(function (item, index) {
            var valueElement = item.querySelector('[data-clinical-stat-value]');
            var targetText = valueElement ? valueElement.getAttribute('data-clinical-stat-value') : '';

            window.setTimeout(function () {
              if (valueElement && targetText) {
                valueElement.textContent = formatStatValue(0, targetText.indexOf('+') === 0, targetText.indexOf('%') !== -1);
                animateStatValue(valueElement, targetText);
              }
            }, index * 120);
          });
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.25
      }
    );

    observer.observe(block);
  }

  function initAll() {
    document.querySelectorAll('.ag-long-blocks__clinical-stats[data-animate="true"]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
